export default "__VITE_ASSET__CgaKHVAf__"